import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatCardModule } from '@angular/material/card';
import { Program } from '../../models';

@Component({
    selector: 'app-program-card',
    templateUrl: './program-card.component.html',
    styleUrls: ['./program-card.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, MatCardModule, FlexLayoutModule]
})
export class ProgramCardComponent {
    @Input()
    program!: Program;

    @Output() updateSelectedPrograms: EventEmitter<any> = new EventEmitter();

    toggle: boolean = false;

    programCardClick() {
        // add/remove to selectedPrograms in program-card-collection
        this.updateSelectedPrograms.emit(this.program);

        this.toggle = !this.toggle;
    }
}
